import './SkillsSection.css';
import Sphere from '../../Components/Sphere/Sphere';

const SkillsSection = () => {
  return (
    <section className="skills-section" id="skills">
      <div className="skills-heading-container">
        <h2>My Skills</h2>
        <p>
          In this section you get a preview of my experince with languages and
          tools
        </p>
      </div>
      <div className="skills-content-container bg-wrapper">
        <div className="skills-sphere-container">
          <Sphere />
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
